import 'css/mobile/blog-display.scss';

import 'js/mobile/common/common.jquery.js';
